import SelectElement from '../../../../../../components/forms/SelectElement';
import { testLabelOptions } from '../../../../../../data/option-objects/examOptions';
import type {
	ExamLabel,
	Question
} from '../../../../../../data/interface-question';
import type { QuestionBankID } from '../../../../../../data/interface-question-bank';
import type { OptionObjMustHaves } from '../../../../../../data/interface-utils';

interface FilterByEnurmProps {
	// issuesFilter: boolean;
	// categorySelect: string;
	// enurmSelect: string;
	filterBySource: (e: string) => void;
	questionBankID: QuestionBankID;
	source: ExamLabel | 'default';
	questions: Question[];
}

const FilterByEnurm = ({
	// issuesFilter,
	// categorySelect,
	// enurmSelect,
	filterBySource,
	questionBankID,
	source,
	questions
}: FilterByEnurmProps) => {
	// return (
	// <div>
	// {issuesFilter === false && categorySelect === 'default' && (
	// <div className='col 12'>
	// <select
	// className='browser-default'
	// id='category'
	// name='category'
	// defaultValue={enurmSelect}
	// onChange={filterByEnurm}
	// tabIndex={1}
	// // disabled={issuesFilter ? 'disabled' : 'false'}
	// required>
	// <option value='default' disabled>
	// -- ENURM or PrepMed --
	// </option>
	// <option value='all'>Show All</option>
	// <option value='prepmed'>PrepMep</option>
	// <option value='evaluacion-1'>Evaluación Diagnóstica 1</option>
	// <option value='evaluacion-2'>Evaluación Diagnóstica 2</option>
	// <option value='enurm-2023-A'>ENURM 2023</option>
	// <option value='enurm-2022-A'>ENURM 2022 A</option>
	// <option value='enurm-2022-B'>ENURM 2022 B</option>
	// <option value='enurm-2022-C'>ENURM 2022 C</option>
	// <option value='enurm-2022-D'>ENURM 2022 D</option>
	// <option value='enurm-2021-A'>ENURM 2021 A</option>
	// <option value='enurm-2021-B'>ENURM 2021 B</option>
	// <option value='enurm-2021-C'>ENURM 2021 C</option>
	// <option value='enurm-2020'>ENURM 2020</option>
	// <option value='enurm-2020'>ENURM 2020</option>
	// <option value='enurm-2019'>ENURM 2019</option>
	// <option value='enurm-2018'>ENURM 2018</option>
	// <option value='enurm-2017'>ENURM 2017</option>
	// <option value='enurm-2016'>ENURM 2016</option>
	// <option value='enurm-2015'>ENURM 2015</option>
	// <option value='enurm-2014'>ENURM 2014</option>
	// <option value='enurm-2013'>ENURM 2013</option>
	// <option value='enurm-2012'>ENURM 2012</option>
	// <option value='enurm-2011'>ENURM 2011</option>
	// <option value='enurm-2010'>ENURM 2010</option>
	// <option value='enurm-2009'>ENURM 2009</option>
	// <option value='enurm-2008'>ENURM 2008</option>
	// <option value='enurm-2007'>ENURM 2007</option>
	// <option value='enurm-2006'>ENURM 2006</option>
	// <option value='enurm-2005'>ENURM 2005</option>
	// <option value='enurm-2004'>ENURM 2004</option>
	// <option value='enurm-2003'>ENURM 2003</option>
	// <option value='enurm-2002'>ENURM 2002</option>
	// <option value='enurm-2001'>ENURM 2001</option>
	// </select>
	// </div>
	// )}
	// </div>
	// );

	const getOptionsWithCounts = (): OptionObjMustHaves[] => {
		const baseOptions =
			questionBankID === 'enurm'
				? testLabelOptions.enurmAdmin
				: testLabelOptions.maxilofacialAdmin;

		return baseOptions.map((option: OptionObjMustHaves) => {
			if (option.id === 'all') {
				return {
					id: option.id,
					value: option.value.concat(` (${questions.length})`)
				};
			} else {
				const count = questions.filter(
					(question) => question.source === option.id
				).length;
				return {
					id: option.id,
					value: option.value.concat(` (${count})`)
				};
			}
		});
	};

	return (
		<SelectElement
			defaultOption='All Sources'
			isDefaultOptionDisabled={false}
			isLabelHidden={true}
			id='source'
			icon='ballot'
			iconFam='material-icons'
			label='Elige un tipo de examen'
			parentClass=''
			options={getOptionsWithCounts()}
			selectClasses='text-sm'
			value={source}
			handleChange={(v) => {
				filterBySource(v);
			}}
		/>
	);
};
export default FilterByEnurm;
